"use strict";

$(function() {
  var bhs_waypoints_animation = require("./modules/waypointsanimation.js");
  bhs_waypoints_animation.init();

  var bhs_teamgrid = require("./modules/team.js");
  bhs_teamgrid.init();

  var quoteblock = require("./modules/quote-block.js");
  quoteblock.init();

  var bhs_hamburger = require("./modules/hamburger.js");
  bhs_hamburger.init();

  var bhs_buttons = require("./modules/buttons.js");
  bhs_buttons.init();

  jQuery("#submit").click(function(e) {
    e.preventDefault();

    var urlSet = $("#sendData").attr("action");

    jQuery.ajax({
      // url: "https://dev.bghdstudio.com/send_email.php",
      url: urlSet,
      type: "POST",
      //data: { image: image, name: image, email: email, telephoneno: telephoneno, schoolname: schoolname },
      data: new FormData(jQuery("#sendData")[0]),
      contentType: false,
      processData: false,
      success: function(data) {}
    });

    $("html, body").animate({ scrollTop: 0 }, "slow");
    $("#name").val("");
    $("#email").val("");
    $("#message").val("");
    $("#reason").val("");
  });
});
